import { useBaseStyles } from './useBaseStyles'
import { styled } from 'goober'
import { useTheme } from '../useTheme'
import { useBreakpoints } from '../useBreakpoints'
import { hexToRGBA } from '../../utils/helpers'

export const useNotificationsListStyles = () => {
  const { P } = useBaseStyles()
  const theme = useTheme()
  const { lgUp, smUp } = useBreakpoints()

  const isDarkMode = theme.palette.mode === 'dark'

  return {
    DeleteNotificationsContainer: styled('div')({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      padding: '0.5rem 1rem',
      paddingRight: '10px',
      backgroundColor: theme.palette.background.paper || '#fff',
      color: theme.palette.text.primary,
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    }),

    DeleteNotificationsTypography: styled(P)({
      width: '100%',
      fontSize: '0.8rem'
    }),

    NotificationsListContainer: styled('div')({
      position: 'relative',
      overflowY: 'auto',
      overflowX: 'hidden',
      scrollBehavior: 'auto',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }),

    ShowAllNotificationsContainer: styled('div')({
      background: theme.palette.secondary.main + '1A',
      padding: '5px 0',
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    })
  }
}
